import React from 'react';
import type { PercentileLevel } from '@talentmesh/utils';

import { Aspect, aspectCompare } from '@/Models/Aspect';

import EICharacteristicAspect from './EICharacteristicAspect';
import EICharacteristicHeader from './EICharacteristicHeader';

interface EICharacteristicPanelProps {
    characteristicName: string;
    percentileScore: number;
    percentileLevel: PercentileLevel;
    aspects: Aspect[];
    importanceRating: number;
}
function EICharacteristicPanel({
    characteristicName,
    percentileScore,
    percentileLevel,
    aspects,
    importanceRating,
}: EICharacteristicPanelProps): React.JSX.Element {
    return (
        <div className="grid grid-cols-12 pt-4">
            <EICharacteristicHeader
                characteristicName={characteristicName}
                percentileScore={percentileScore}
                percentileLevel={percentileLevel}
                importanceRating={importanceRating}
            />
            {aspects.sort(aspectCompare).map((aspect) => (
                <EICharacteristicAspect key={aspect.descriptor} {...aspect} />
            ))}
        </div>
    );
}

export default EICharacteristicPanel;
